import { render } from "./layOut.vue?vue&type=template&id=4740ba99&scoped=true"
import script from "./layOut.vue?vue&type=script&lang=js"
export * from "./layOut.vue?vue&type=script&lang=js"

import "./layOut.vue?vue&type=style&index=0&id=4740ba99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4740ba99"]])

export default __exports__